
export function checkSubmitError(riskgradeList) {
    let res = false
    if (riskgradeList.length === 0) {
        return true;
    }
    for (let i = 0; i < riskgradeList.length; i++) {
        if (!riskgradeList[i].minScore.toString()
            || !riskgradeList[i].maxScore.toString()
            || !riskgradeList[i].riskGrade.toString()
            || !riskgradeList[i].riskLevel.toString()
            || !riskgradeList[i].gradeDescription.toString()
            || !riskgradeList[i].pd.toString()) {
            res = true
        }

    }
    /* riskgradeList.forEach((values) => {
        if (!values.minScore
            || !values.maxScore
            || !values.riskGrade
            || !values.riskLevel
            || !values.gradeDescription
            || !values.pd)
            res = true
    }) */
    return res
}
export function checkOne(riskgradeList) {
    let res = false
    if (riskgradeList.length === 0)
        return true
    return res
}

export function checkZeroValue(values) {
    let financialValue = {}
    let nonFinancialValue = {}
    if (values.financialRiskFactorList) {
        Object.keys(values.financialRiskFactorList).forEach((key) => {
            if (parseInt(values.financialRiskFactorList[key], 10) !== 0) {
                // let value = values.financial[key]
                financialValue[key] = values.financialRiskFactorList[key]
            }
        })

        values.financialRiskFactorList = financialValue
    }
    if (values.nonFinancialRiskFactorList) {
        Object.keys(values.nonFinancialRiskFactorList).forEach((key) => {
            if (parseInt(values.nonFinancialRiskFactorList[key], 10) !== 0) {
                // let val = values.nonfinancial[key]
                nonFinancialValue[key] = values.nonFinancialRiskFactorList[key]
            }
        })
        values.nonFinancialRiskFactorList = nonFinancialValue
    }
    return values
}

export function addStatus(products, status) {
    let list = Object.entries(products).length ? [...products] : [];
    if (Object.keys(list).length !== 0) {
        list.forEach((value) => {
            let val = Object.assign({}, value);
            val.status = status
        })
    }

    return list
}

export function checkStatus(products, scorecardList, editData) {
    let productList = JSON.parse(JSON.stringify(products))
    // let scorecardList = JSON.parse(JSON.stringify(scorecards))
    scorecardList.forEach((scorecard) => {
        scorecard.enabled = false
    })
    productList.forEach((product, index) => {
        let flag = false
        scorecardList.forEach((scorecard, index) => {
            if (scorecard.productId === product.id) {
                if (scorecard.sectionList) { //&& JSON.stringify(scorecard.sectionList) === JSON.stringify(product.sectionList)

                    flag = true
                    product.status = true
                    scorecard.enabled = product.enabled
                }
                else if (editData) { //&& JSON.stringify((editData.data.productList.find(o => o.id === product.id).sectionList)) === JSON.stringify(product.sectionList)

                    flag = true
                    product.status = true
                    scorecard.enabled = product.enabled
                }
                else {
                    flag = false
                    scorecard.enabled = false
                    product.status = false
                }

            }
            else if (flag === false && index === scorecardList.length - 1) {
                product.status = false
            }
        })

    })
    return productList
}

export function changeStatus(products, selectedProduct) {
    let productList = JSON.parse(JSON.stringify(products))
    productList.forEach((value) => {
        if (value.id === selectedProduct.id) {
            value.status = true
        }
    })
    return productList
}

export function saveEditedData(scorecardData, formvalue, riskFactors, sectionList) {
    let flag = false
    let financialData = []
    let nonFinancialData = []
    if (formvalue.financialRiskFactorList) {
        riskFactors.financialFactors.forEach((value) => {
            if (formvalue.financialRiskFactorList[value.id]) {
                let newObj = {
                    id: value.id,
                    name: value.name,
                    assignedWeight: formvalue.financialRiskFactorList[value.id]
                }
                financialData = [...financialData, newObj]
            }
        })
        formvalue.financialRiskFactorList = financialData
    }


    if (formvalue.nonFinancialRiskFactorList) {
        riskFactors.nonFinancialFactors.forEach((value) => {
            if (formvalue.nonFinancialRiskFactorList[value.id]) {
                let newObj = {
                    id: value.id,
                    name: value.name,
                    assignedWeight: formvalue.nonFinancialRiskFactorList[value.id]
                }
                nonFinancialData = [...nonFinancialData, newObj]
            }
        })
        formvalue.nonFinancialRiskFactorList = nonFinancialData
    }

    // formvalue.productId = formvalue.id
    formvalue.sectionList = sectionList
    formvalue.enabled = true
    scorecardData.forEach((value, index) => {
        if (value.productId === formvalue.productId) {
            formvalue.id = scorecardData[index].id ? scorecardData[index].id : ""
            formvalue.name = scorecardData[index].name ? scorecardData[index].name : null
            scorecardData[index] = formvalue
            flag = true
        }
    })
    if (scorecardData.length === 0 || flag === false) {
        scorecardData = [...scorecardData, formvalue]
    }
    return scorecardData
}

export function findEditData(id, savedData) {
    let data
    savedData.forEach((value) => {
        if (value.productId === id) {
            data = value
        }
    })
    let newData = {
        financialRiskFactorList: {},
        nonFinancialRiskFactorList: {}
    }
    if (data.financialRiskFactorList) {
        data.financialRiskFactorList.forEach((value) => {
            if (value.id) {
                newData.financialRiskFactorList[value.id] = value.assignedWeight
            }
        })
    }
    if (data.nonFinancialRiskFactorList) {
        data.nonFinancialRiskFactorList.forEach((value) => {
            if (value.id) {
                newData.nonFinancialRiskFactorList[value.id] = value.assignedWeight
            }
        })
    }
    newData.riskGrades = data.riskGrades
    return newData
}